import { Container, Flex } from '@chakra-ui/react';

import { FooterProps } from '@/models/props/NavigationFooterProps';

import { FooterNavigation } from './FooterNavigation';
import { SocialMedia } from './SocialMedia';

export const Footer = (props: FooterProps) => {
    const { menu, socialLinks } = props;

    return (
        <Container
            as="footer"
            maxW="full"
            backgroundColor="grey.100"
            className="page-footer"
            py={14}
        >
            <Flex
                maxW="container.3xl"
                flexDirection="column"
                justifyContent="flex-start"
                rowGap={8}
                mx="auto"
            >
                <Flex
                    flexDirection={{ base: 'column', lg: 'row' }}
                    justifyContent={{ base: 'center', lg: 'space-between' }}
                    alignItems="center"
                    rowGap={9}
                >
                    <FooterNavigation menu={menu} />
                    <SocialMedia socialLinks={socialLinks} />
                </Flex>
            </Flex>
        </Container>
    );
};
